module.exports = __webpack_public_path__ + "assets/img/team/marko-horvat.jpg";